import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import BreadcrumbMappersFactory from '../Mappers/factory.js'

class GetBreadcrumbsBreadcrumbUseCase extends UseCase {
  #breadcrumbProxyMapper

  constructor({breadcrumbProxyMapper}) {
    super()
    this.#breadcrumbProxyMapper = breadcrumbProxyMapper
  }

  static create({config}) {
    return new GetBreadcrumbsBreadcrumbUseCase({
      breadcrumbProxyMapper: BreadcrumbMappersFactory.breadcrumbProxyMapper({config})
    })
  }

  @tracer({metric: 'GetBreadcrumbsBreadcrumbUseCase#execute'})
  @AsyncInlineError()
  async execute({pageName, params = {}}) {
    const breadcrumbVO = this.#breadcrumbProxyMapper.createFor({pageName, params})
    return breadcrumbVO.toJSON()
  }
}
export const factory = GetBreadcrumbsBreadcrumbUseCase.create
